import { IWealthicaInitResponse } from 'api/wealthica/models'
import WealthicaAPI, { UNIFIED_ADDON_PREFIX } from 'api/wealthica/services'
import dayjs from 'dayjs'
import { useAppContext } from 'modules/common/appContext'
import { useEffect } from 'react'

export function usePlanUpgradeChecking() {
	const { isWealthicaContext, setWealthicaContext, wealthicaContext } = useAppContext()

	useEffect(() => {
		let planCheckingInterval: NodeJS.Timer
		if (isWealthicaContext) {
			planCheckingInterval = setInterval(async () => {
				const subscriptionResponse = await WealthicaAPI.getSubscription()
				const subscription = subscriptionResponse.find(
					({ is_active, plan }) => is_active && plan.includes(UNIFIED_ADDON_PREFIX)
				)
				if (wealthicaContext?.plan !== subscription?.plan) {
					const paidUntilDate = subscription?.expires_at || subscription?.renew_at
					setWealthicaContext?.(
						prev =>
							({
								...prev,
								plan: subscription?.plan,
								paidUntil: paidUntilDate ? dayjs(paidUntilDate).toDate() : undefined,
							} as IWealthicaInitResponse | undefined)
					)
				}
			}, 10000)
		}

		return () => {
			if (isWealthicaContext && planCheckingInterval) {
				clearInterval(planCheckingInterval)
			}
		}
	}, [isWealthicaContext])
}
